<template>
  <v-card flat>
    <v-toolbar flat>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div v-if="canShareProject && !addMode && unassigned.length !== 0">
      <v-tooltip bottom open-delay="100">
        <template v-slot:activator="{ on }">
          <v-btn
              id="addBtnId"
              v-on="on"
              @click="add()"
              class="primary"
          >
            <v-icon left>mdi-share-variant</v-icon>
            {{ $t('app.button.share') }}
          </v-btn>
        </template>
        <span>{{ actualShareTooltip }}</span>
      </v-tooltip>
      </div>
      <div v-if="addMode">
        <v-btn
            id="cancelBtnId"
            text
            @click="cancel()"
        >
          {{ $t('app.button.cancel') }}
        </v-btn>
        <v-btn
            id="saveBtnId"
            class="primary"
            @click="save()"
            :disabled="unassignedIndexes.length === 0"
        >
          {{ $t('app.button.save') }}
        </v-btn>
      </div>
    </v-toolbar>
    <v-text-field
        v-if="addMode"
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        class="px-4"
    ></v-text-field>
    <v-list
        v-if="addMode"
        :max-height="addMode ? '60vh' : '20vh'"
        style="overflow-y: auto"
    >
      <v-list-item-group
          v-model="unassignedIndexes"
          multiple
          :two-line="twoLine"
      >
        <UnassignedItem
            v-for="item in filteredUnassigned"
            :key="unassignedValue(item)"
            :item="item"
            @read-only="readOnlyClicked"
            v-show="true">
        </UnassignedItem>
      </v-list-item-group>
    </v-list>
    <v-list
        v-else
        :two-line="twoLine"
        :max-height="addMode ? '60vh' : '20vh'"
        style="overflow-y: auto"
    >
      <v-list-item-group>
        <template v-for="item in shares">
          <v-list-item :key="assignedValue(item)">
            <v-list-item-content>
              <v-list-item-title v-text="assignedText(item)"></v-list-item-title>
              <v-list-item-subtitle v-if="twoLine">{{ twoLineValue(item) }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-icon v-if="!item.mode.write">
              <v-tooltip bottom open-delay="600">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="grey darken-1">mdi-pencil-off</v-icon>
                </template>
                <span>{{ $t('app.tooltip.readOnlyShare') }}</span>
              </v-tooltip>
            </v-list-item-icon>
            <v-list-item-action v-if="item.canRevoke">
              <v-tooltip bottom open-delay="600">
                <template v-slot:activator="{ on }">
                  <v-btn
                      :id="`${deleteBtnId}_${assignedValue(item)}`"
                      v-on="on"
                      icon
                      @click="deleteShareWith(assignedValue(item))"
                  >
                    <v-icon color="grey lighten-1">mdi-minus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('app.tooltip.removeShare') }}</span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import UnassignedItem from "./UnassignedItem";
import {mapState} from 'vuex';

export default {
  props: ["unassigned", "shares", "title", "addBtnId", "cancelBtnId", "saveBtnId", "deleteBtnId", "twoLine", "shareTooltip"],
  inject: ["assignedValue", "assignedText", "unassignedValue", "unassignedText", "shareWith", "deleteShareWith", "twoLineValue"],
  components: {
    UnassignedItem,
  },
  data() {
    return {
      search: "",
      addMode: false,
      unassignedIndexes: [],
      readOnlyShares: {}
    }
  },
  watch: {
    search: function () {
      this.unassignedIndexes.splice(0, this.unassignedIndexes.length)
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState(["project"]),
    canShareProject() {
      return this.user && this.project && (
          this.user.permissions.indexOf(`chmodProject:${this.project.name}`) !== -1 ||
          this.user.permissions.indexOf(`chmodProject:*`) !== -1
      )
    },
    filteredUnassigned() {
      return !this.search || this.search === '' ? this.unassigned : this.unassigned.filter(item => this.unassignedText(item).search(this.search) !== -1)
    },
    actualShareTooltip() {
      return this.shareTooltip ? this.shareTooltip : this.$t('app.button.add')
    }
  },
  methods: {
    add() {
      this.$emit("add-mode", true)
      this.addMode = true
    },
    cancel() {
      this.addMode = false
      this.search = ""
      this.unassignedIndexes.splice(0, this.unassignedIndexes.length)
      this.readOnlyShares = {}
      this.$emit("add-mode", false)
    },
    readOnlyClicked({itemValue, readOnly}) {
      if (readOnly)
        this.readOnlyShares[itemValue] = "true"
      else
        delete this.readOnlyShares[itemValue]
    },
    async save() {
      const selectedItemsInFiltered = this.unassignedIndexes.map(index => this.filteredUnassigned[index])
      // console.log(JSON.stringify(selectedItemsInFiltered))
      const self = this
      const indexesInUnfiltered = selectedItemsInFiltered.map(item => self.unassigned.findIndex(item2 => self.unassignedText(item) === self.unassignedText(item2)))
      // console.log(indexesInUnfiltered)
      // const selectedItemsUnfiltered = indexesInUnfiltered.map(index => this.unassigned[index])
      // console.log(JSON.stringify(selectedItemsUnfiltered))
      const unassignedIndexes = [...indexesInUnfiltered]
      const readOnlyShares = {...this.readOnlyShares}
      this.cancel()
      await this.shareWith({unassignedIndexes, readOnlyShares})
    },
  }
}
</script>